// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2OjUg","actionsCol":"EnrolledClinics_actionsCol__n8VHp"};